// extracted by mini-css-extract-plugin
module.exports = {"text":"DropDownInput_text__3QOUA FormField_text__3CRh7 font_normal__3xTtI","button":"DropDownInput_button__1oHqm"};